import { useCallback } from "react";

import { DevelopmentTools } from "@/hooks/use-development-tools";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

// eslint-disable-next-line import/no-restricted-paths
import type { NetworkError } from "@apollo/client/errors";

/**
 * Network Error のハンドリングを行う
 */
export const useNetworkErrorHandler = () => {
	const onHandleNetworkError = useCallback(
		(networkError: NetworkError, notification: { title: string; description?: string }) => {
			const { consoleErrorOnlyDevMode } = DevelopmentTools();
			consoleErrorOnlyDevMode("[GraphQL Client] networkError", networkError);

			notifyUserEventInfo({
				variant: "error",
				title: notification.title,
				description: notification.description ?? "",
			});
		},
		[],
	);

	return {
		onHandleNetworkError,
	};
};
